export default __webpack_public_path__ + "locales/ro/Payments.json?hash=1fb644ff8678c22db08e6a83c95c5ecc";